export default {
  data() {
    return {
      isMobile: false,
      isChinaMobile: false
    }
  },

  created() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    const chinaPhones = ['Oneplus', 'Xiaomi', 'Oppo']

    let isMobile = toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })

    for (const phoneName of chinaPhones.values()) {
      if (navigator.userAgent.toLowerCase().indexOf(phoneName.toLowerCase()) >= 0) {
        this.isChinaMobile = true
      }
    }

    if (!isMobile) {
      isMobile = navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
    }

    this.isMobile = isMobile
  }
}